"use client";
import { usePassportProvider } from "@/context";
import { Action } from "@/context/AnalyticsProvider";
import { GamePageSection } from "@/context/AnalyticsProvider/gamePage";
import { LoaderCircle } from "lucide-react";
import { useEffect } from "react";
import type { GPOnboardingStepProps } from "./utils";

export const BronzeRewardAchieved = ({
  onNext,
  isVisible,
  track,
}: GPOnboardingStepProps) => {
  const { isInitializing } = usePassportProvider();

  useEffect(() => {
    if (!isVisible || isInitializing) return;

    track({
      action: Action.SUCCEEDED,
      extras: {
        control: "bronze-reward",
        section: GamePageSection.ONBOARDING_MODAL,
      },
    });

    const timeout = setTimeout(() => onNext(), 1500);
    return () => clearTimeout(timeout);
  }, [onNext, isVisible, track, isInitializing]);

  return (
    <div className="flex-grow flex flex-col items-center justify-between gap-y-10">
      {/* Title */}
      <div>
        <h2 className="text-[clamp(1.25rem,6.25vw,1.875rem)] font-bold leading-[clamp(1.5rem,6.25vw,2.25rem)] text-center">
          Reward upgraded to
          <br />
          Bronze tier
        </h2>
      </div>
      <LoaderCircle className="size-10 animate-spin" />
      <div />
    </div>
  );
};
